import axios from "axios";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import DetailsSouvenir from "./DetailsSouvenir";
import "./SouvenirMain.css";

const SouvenirMain = () => {
  const [checkSouviner, setCheckSouvenir] = useState({});
  const [loading, setloading] = useState(true);
  // const [status, setStatus] = useState(false);

  useEffect(() => {
    axios.get("/api/admin/souviner/check").then((res) => {
      if (res.data.status === 200) {
        setCheckSouvenir(res.data?.getUser);
        // setStatus(res.data.action)
        setloading(false);
      }
      //  else {
      //     swal("error", "Data base Error", "error");
      // }
    });
  }, []);

  return (
    <>
      {loading === true ? (
        <>
          <h5 className="text-white justify-content-center text-center mx-auto souvinerStyle">
            <div className="greetingsHeight d-flex justify-content-center align-items-center">
              <Spinner
                animation="border"
                variant="warning"
                className="souvinerStyle"
                style={{
                  height: "100px",
                  width: "100px",
                  border: "10px dashed",
                }}
              />
            </div>
          </h5>
        </>
      ) : (
        <>
          {checkSouviner ? (
            <DetailsSouvenir souviner={checkSouviner} />
          ) : (
            <div className="greetingsHeight d-flex justify-content-center align-items-center">
              <div className="text-center">
                <div className="box-open">
                  <i
                    style={{ color: "#ffc107" }}
                    className="fas fa-box-open"
                  ></i>
                </div>
                <div className="text-white">
                  <h3>No Data Here</h3>
                  <p>
                    <big>Create souvenir profile for you</big>
                  </p>
                  <p className="text-muted">
                    <small>
                      A default souvenir profile will enable the users <br /> to
                      understand and apply for souvenir videos
                    </small>
                  </p>
                </div>

                <Link to="/superstar-admin/souvenir/create">
                  <button className="btn btn-warning mt-2 w-50">
                    Create New
                  </button>
                </Link>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default SouvenirMain;
